import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal';

export type LockedFeatureVariant = 'feature-locked' | 'request-cap';

@Component({
  selector: 'app-locked-feature-modal',
  templateUrl: './locked-feature-modal.component.pug',
  styleUrls: ['./locked-feature-modal.component.scss'],
  standalone: false,
})
export class LockedFeatureModalComponent implements OnInit {
  variant: LockedFeatureVariant = 'feature-locked';
  title = '';
  description = '';
  badgeText = '';
  primaryButtonText = $localize`Activate subscription`;
  cancelButtonText = $localize`Cancel`;

  private variantConfig: Record<LockedFeatureVariant, { title: string; description: string; badgeText: string }> = {
    'feature-locked': {
      title: $localize`Activate your subscription to unlock this feature`,
      description: $localize`Activate your subscription now to gain access to powerful tools such as Custom Questions, Share Reports and Bulk Recipients.`,
      badgeText: $localize`Feature locked`,
    },
    'request-cap': {
      title: $localize`Activate your subscription to send more requests`,
      description: $localize`You've reached the maximum turnover cap for your trial. Activate your subscription to continue sending Reference or Exit requests.`,
      badgeText: $localize`Request cap reached`,
    },
  };

  constructor(
    private _bsModalRef: BsModalRef,
    private router: Router
  ) {}

  ngOnInit(): void {
    const config = this.variantConfig[this.variant];
    this.title = this.title || config.title;
    this.description = this.description || config.description;
    this.badgeText = this.badgeText || config.badgeText;
  }

  onPrimaryAction(): void {
    this._bsModalRef.hide();
    this.router.navigate(['/plan-comparison']);
  }

  onCancel(): void {
    this._bsModalRef.hide();
  }
}
